import React, { useContext, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { GlobalContext } from '../../../App';

const DontAccess = ({ imageSrc, text }) => {

 const { setBackgroundColor } = useContext(GlobalContext);

 useEffect(() => {
  setBackgroundColor('transparent'); // הגדרת רקע שקוף עבור הקומפוננטה
  return () => setBackgroundColor('white'); // הגדרת רקע ברירת מחדל כאשר הקומפוננטה מתנתקת
 }, [setBackgroundColor]);


  return (
   <div style={{ backgroundColor: 'transparent', border: 'none' }}>
    <Box
      sx={{
        height: 'calc(100vh - 300px)', // גובה יתרת המסך
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box
        component="img"
        src={imageSrc}
        alt="Centered"
        sx={{
          width: '450px',
          height: '450px',
          objectFit: 'cover',
          mb: 2, // מרווח מתחת לתמונה
        }}
      />
      <Typography variant="h6">{text}</Typography>
    </Box>
   </div>
  );
};

export default DontAccess;
